export default function digit4ToTimeString(digit4String: string) {
  if (new RegExp(/\d\d:\d\d/).test(digit4String)) {
    return digit4String;
  }
  if (!digit4String || digit4String?.length !== 4) {
    return null;
  }
  return [digit4String.slice(0, 2), digit4String.slice(2, 4)].join(":");
}
